<template>
    <div class="is-width-fill">
        <PageHead title="Self Fulfillment" />

        <div class="box">
            <div class="box-title">
                Self Fulfillment
            </div>

            <template v-for="order in props.fulfillmentOrders">
                <FulfillmentOrderItem :fulfillment-order="order" />
            </template>
        </div>
    </div>
</template>

<script setup lang="ts">
import Base from "@/Layouts/Base.vue";
import Default from "@/Layouts/Default.vue";
import PageHead from "@/Components/PageHead.vue";
import {FulfillmentOrder} from "@/Types/FulfillmentOrder";
import FulfillmentOrderItem from "@/Components/FulfillmentOrderItem.vue";

defineOptions({
    layout: [Base, Default]
});

const props = defineProps<{
    fulfillmentOrders: FulfillmentOrder[]
}>();
</script>
